/* eslint-disable max-len */
import { Button, Grid, IconButton, InputLabel, Link, Menu, MenuItem, Typography } from '@material-ui/core'
import { ArrowLeftIcon, ShareIcon } from 'asterX-UI/Icons'
import { PageContainer } from 'components/PageContainer'
import { useRoutes } from 'lib/hooks'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import { AsterChip } from 'asterX-UI/Chip'
import { getStatusColor, getStatusLabel } from 'lib/constants/deals'
import { UserInfo } from 'asterX-UI/DataDisplay'
import { PluseIcon } from 'asterX-UI/Icons/PlusIcon'
import { PrinterIcon } from 'asterX-UI/Icons/PrinterIcon'
import { EmailIcon } from 'asterX-UI/Icons/EmailIcon'
import { WhatsappIcon } from 'asterX-UI/Icons/WhatsappIcon'
import { ContractTabs } from 'components/ContractTabs/ContractTabs'
import { useContractStore } from 'context/ContractStore'
import { getFullName, getValidDate } from 'lib/utils'
import React, { useEffect, useState } from 'react'
import { GetManagerIcon } from 'asterX-UI/Icons/GetManagerIcon'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { AutoCompleteField } from 'asterX-UI/Inputs'
import { useSnackbar } from 'notistack'
import { CollectionService } from 'lib/api/services/collection.service'
import { useAuthStore } from 'context/AuthStore'
import { Call, MoreHoriz } from '@material-ui/icons'
import { debounce } from 'lodash'
import BottomDialog from 'asterX-UI/BottomDialog/BottomDialog'
import { useLocation } from 'react-router'
import { APPLICATION_PATH } from '../../routes/constants.routes'
import AddDeferralModal from '../../components/AddDefferal/AddDeferralModal'
import { useStyles } from './contract-page.styles'
import { AddEvents } from './components/AddEvents/AddEvents'
import { AddLawyerEvents } from './components/AddLawyerEvents/AddLawyerEvents'

const ContractPage = () => {
  const { goPrevPage } = useRoutes()
  const routes = useRoutes()
  const { enqueueSnackbar } = useSnackbar()
  const { search, pathname } = useLocation()
  const qs = new URLSearchParams(search)
  const src = qs.get('src')
  const ret = qs.get('return')
  const classes = useStyles()
  const { authStore, authStoreFunc } = useAuthStore()
  const {
    contractStore: { contractAll, eventPhoneNumbers, managers },
    contractStoreFunc:{getById}
  } = useContractStore()

  const [openEvent, setOpenEvent] = useState(false)
  const [openAction, setOpenAction] = useState(false)
  const [openLawyerEvent, setOpenLawyerEvent] = useState(false)
  const [openAssignManager, setOpenAssignManager] = useState(false)
  const [openResumptionModal, setOpenResumptionModal] = useState(false)
  const [openEmail, setOpenEmail] = useState(false)
  const [openDeferral, setOpenDeferral] = useState(false)
  const [assignManager, setAssignManager] = useState(null)
  const [calledPhoneNumber, setCalledPhoneNumber] = useState(null)

  const [phoneAnchorEl, setPhoneAnchorEl] = useState(null)
  const [docAnchorEl, setDocAnchorEl] = useState(null)

  const openPhoneMenu = Boolean(phoneAnchorEl)
  const openDocMenu = Boolean(docAnchorEl)

  useEffect(() => {
    if (openAssignManager) {
      setAssignManager(contractAll?.assignTo)
    }
  }, [openAssignManager])

  const handleChangeManager = event => {
    setAssignManager(event.target.value)
  }

  const handleCloseAssignManager = () => {
    setOpenAssignManager(false)
  }

  const handleCloseEmail = () => {
    setOpenEmail(false)
  }

  const handleCloseEvent = () => {
    setOpenEvent(false)
    setCalledPhoneNumber(null)
  }

  const handleOpenLaywerEvent = () => {
    if (!contractAll?.assignTo) {
      enqueueSnackbar('Выберите менеджера', { variant: 'warning' })
      return
    }

    setOpenLawyerEvent(true)
  }

  const handleOpenEvent = () => {
    if (!contractAll?.assignTo) {
      enqueueSnackbar('Выберите менеджера', { variant: 'warning' })
      return
    }

    setOpenEvent(true)
  }

  const openPhoneList = event => {
    setPhoneAnchorEl(event.currentTarget)
  }

  const openDocList = event => {
    setDocAnchorEl(event.currentTarget)
  }

  const closePhoneList = () => {
    setPhoneAnchorEl(null)
  }

  const closeDocList = () => {
    setDocAnchorEl(null)
  }

  const handleAssignTo = debounce(async () => {
    if (!assignManager) {
      enqueueSnackbar('Выберите менеджера', { variant: 'warning' })
      return
    }
    const manager = managers.find(manager => manager?.username === assignManager)
    const data = {
      idList: [contractAll?.id],
      assignTo: assignManager,
      assignToFullName: `${manager?.lastName} ${manager?.firstName}`
    }

    const res = await CollectionService.updateListAssignTo(data)

    if (res?.data) {
      enqueueSnackbar('Успешно 😸', { variant: 'success' })
      setOpenAssignManager(false)
      getById()
    } else {
      enqueueSnackbar('Ошибка 😿', { variant: 'error' })
    }
  }, 300)

  const handleCallPhone = async item => {
    const data = {
      workListId: contractAll?.id,
      clientPhoneNumber: item
    }

    const res = await CollectionService.createCall(data)

    if (res?.data) {
      enqueueSnackbar('Звонок успешно создан', { variant: 'success' })
      setOpenEvent(true)
      setCalledPhoneNumber(item)
    } else {
      enqueueSnackbar(`😿 Ошибка создания звонка, статус ${res?.status}`, { variant: 'error' })
      return
    }

    setPhoneAnchorEl(null)
    const sipUri = `sip:${item}`
    window.location.href = sipUri
  }

  const handleUpdateLegalAssignTo = debounce(async () => {
    const { username, firstName, lastName } = authStore.user.data
    const data = {
      id: contractAll?.id,
      assignTo: username,
      assignToFullName: `${lastName} ${firstName}`
    }

    const res = await CollectionService.updateLegalAssignTo(data)

    if (res?.data) {
      enqueueSnackbar('Успешно', { variant: 'success' })
      setOpenResumptionModal(false)
    } else {
      enqueueSnackbar(`😿 Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
    }
  }, 300)

  const sendEmail = debounce(async () => {
    const res = await CollectionService.sendEmail(contractAll?.id)
    if (res?.data) {
      enqueueSnackbar(`Успешно отправлено`, { variant: 'success' })
      setOpenEmail(false)
    } else {
      enqueueSnackbar(`Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
    }
  }, 300)

  const handleGetDoc = debounce(async doc => {
    const data = {
      contractId: contractAll?.contract?.contractId,
      template: doc
    }

    try {
      const res = await CollectionService.getDocs(data)

      if (!res?.data) {
        enqueueSnackbar(`Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
        return
      }

      const disposition = res.headers['content-disposition']
      const contentType = res.headers['content-type']
      const blob = new Blob([res.data], { type: contentType })

      let fileName = doc
      if (disposition && disposition.includes('attachment')) {
        const fileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (fileNameMatch != null && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, '')
        }
      }

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Ошибка при загрузке файла', error)
    }

    setDocAnchorEl(null)
  }, 300)

  const handleBack = () => {
    if (src === 'application' && ret) {
      return routes.push(decodeURIComponent(ret))
    }
    goPrevPage()
  }

  const redirectApplicationPage = () => {
    if (!contractAll?.applicationId) return
    const returnUrl = `${pathname}${search}`
    routes.push(`${APPLICATION_PATH}/${contractAll?.applicationId}?src=application&return=${encodeURIComponent(returnUrl)}`)
  }

  return (
    <PageContainer>
      <Grid container>
        <Grid item xs={12} className={classes.arrowLeft}>
          <Button size="small" onClick={handleBack} color="primary" className={classes.backButton}>
            <ArrowLeftIcon />
            Назад
          </Button>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={4}
        className={classes.header}
      >
        <Grid item xs={12} md={4}>
          <Typography className={classes.headerTitle}>{`Контракт № ${
            contractAll?.contract?.contractName || 'нет данных'
          }`}</Typography>
          <Typography variant="body2">{`Дата создания:  ${getValidDate(
            contractAll?.contract?.creationDate
          )}`}</Typography>
        </Grid>
        <Grid item xs={12} md={8} className={classes.headerItems}>
          <Grid item>
            <FieldInfoNG label="Тип просрочки" isVertical>
              <AsterChip label={contractAll?.overdueType} />
            </FieldInfoNG>
          </Grid>
          <Grid item>
            <FieldInfoNG label="Статус" isVertical>
              <Grid item>
                <AsterChip
                  label={
                    contractAll?.closeReason ||
                    contractAll?.statusName ||
                    getStatusLabel(contractAll?.workListStatusCode)
                  }
                  style={
                    contractAll?.closeReason
                      ? getStatusColor('COMPLETED')
                      : getStatusColor(contractAll?.statusCode || contractAll?.workListStatusCode || 'Новый')
                  }
                />
              </Grid>
            </FieldInfoNG>
          </Grid>
          <Grid item>
            <FieldInfoNG label="Менеджер:" isVertical>
              <Grid item xs={12} container display="flex">
                <Typography variant="body2" className={classes.assignManager}>
                  {contractAll?.assignToFullName || 'Выберите менеджера'}
                </Typography>
                {authStoreFunc.isAdmin() && !['COMPLETED'].includes(contractAll.workListStatusCode) && (
                  <IconButton className={classes.managerIcon} onClick={() => setOpenAssignManager(true)}>
                    <GetManagerIcon />
                  </IconButton>
                )}
              </Grid>
            </FieldInfoNG>
          </Grid>
          <Grid item>
            <UserInfo
              avatar={contractAll?.userPhoto}
              fullName={getFullName(
                contractAll?.client?.lastName,
                contractAll?.client?.firstName,
                contractAll?.client?.patronymic,
                contractAll?.client?.titleName
              )}
              phone={contractAll?.client?.mobilePhone?.toString()?.toPhone()}
            />
          </Grid>
        </Grid>
      </Grid>

      {authStoreFunc.isLawyer() && (
        <Grid item container xs={12} display="flex" alignItems="center" className={classes.actionButtons}>
          {contractAll?.overdueType !== 'LEGAL' && contractAll?.hadLegalStatus ? (
            <Button variant="outlined" color="primary" onClick={() => setOpenResumptionModal(true)}>
              Возобновить судебный процесc
            </Button>
          ) : (
            <Button variant="outlined" color="primary" onClick={handleOpenLaywerEvent}>
              <PluseIcon />
              Добавить действие
            </Button>
          )}
        </Grid>
      )}

      <Grid
        item
        container
        xs={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className={classes.actionButtons}
      >
        <Grid item>
          <Grid container spacing={2} wrap="wrap" alignItems="center">
            {authStoreFunc.isManager() && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleOpenEvent}
                  style={{ height: 48, fontWeight: 600 }}
                >
                  <PluseIcon />
                  &nbsp;Добавить действие
                </Button>
              </Grid>
            )}

            {contractAll?.applicationId && src !== 'application' && !authStoreFunc?.isLawyer() ? (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={redirectApplicationPage}
                  style={{ height: 48, fontWeight: 600 }}
                >
                  Перейти к заявлению&nbsp;
                  <ShareIcon />
                </Button>
              </Grid>
            ) : (
              authStoreFunc.isManager() && src !== 'application' && (
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setOpenDeferral(true)}
                    style={{ height: 48, fontWeight: 600 }}
                  >
                    <PluseIcon />
                    &nbsp;Отправить заявление
                  </Button>
                </Grid>
              )
            )}
          </Grid>
        </Grid>

        {authStore.isMobile && authStoreFunc.isManager() && (
          <IconButton
            className={classes.actionItemsBtn}
            style={{ padding: 10 }}
            variant="outlined"
            onClick={() => setOpenAction(true)}
          >
            <MoreHoriz />
          </IconButton>
        )}

        {!authStore.isMobile && authStoreFunc.isManager() && (
          <Grid item className={classes.actionItems}>
            <Grid item>
              <Button
                variant="outlined"
                id="call-button"
                aria-controls={openPhoneMenu ? 'call-menu' : null}
                aria-haspopup="true"
                aria-expanded={openPhoneMenu ? 'true' : null}
                onClick={openPhoneList}
              >
                <Call />
                Позвонить
              </Button>
              <Menu
                id="call-menu"
                anchorEl={phoneAnchorEl}
                open={openPhoneMenu}
                onClose={closePhoneList}
                MenuListProps={{ 'aria-labelledby': 'call-button' }}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                {(eventPhoneNumbers || []).map(item => (
                  <MenuItem key={item} value={item} onClick={() => handleCallPhone(item)} className={classes.phoneList}>
                    {item?.toString()?.toPhone()}
                  </MenuItem>
                ))}
              </Menu>
            </Grid>

            <Grid item>
              <Button id="doc-button" variant="outlined" onClick={openDocList}>
                <PrinterIcon />
                Печать
              </Button>
              <Menu
                id="doc-menu"
                anchorEl={docAnchorEl}
                open={openDocMenu}
                onClose={closeDocList}
                MenuListProps={{ 'aria-labelledby': 'doc-button' }}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <MenuItem value="RECOGNITION_DEBT_TEMPLATE" onClick={() => handleGetDoc('RECOGNITION_DEBT_TEMPLATE')} className={classes.docList}>
                  Расписка о признании денежной задолженности
                </MenuItem>
                <MenuItem value="COLLECTION_STATEMENT_TEMPLATE" onClick={() => handleGetDoc('COLLECTION_STATEMENT_TEMPLATE')} className={classes.docList}>
                  Заявление о взыскании
                </MenuItem>
                <MenuItem value="ABOUT_DEBT_TEMPLATE" onClick={() => handleGetDoc('ABOUT_DEBT_TEMPLATE')} className={classes.docList}>
                  Справка о задолженности
                </MenuItem>
                <MenuItem value="CLAIM_AND_DEMAND_TEMPLATE" onClick={() => handleGetDoc('CLAIM_AND_DEMAND_TEMPLATE')} className={classes.docList}>
                  Претензия и Требование
                </MenuItem>
              </Menu>
            </Grid>

            <Grid item>
              <Button variant="outlined" onClick={() => setOpenEmail(true)}>
                <EmailIcon />
                Отправить email
              </Button>
            </Grid>

            <Grid item>
              <Link
                href={`https://api.whatsapp.com/send/?phone=${contractAll?.client?.mobilePhone}&text&type=phone_number&app_absent=0`}
                color="inherit"
                underline="none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outlined">
                  <WhatsappIcon />
                  Написать на Whatsapp
                </Button>
              </Link>
            </Grid>
          </Grid>
        )}
      </Grid>

      <ContractTabs />

      <AddEvents
        open={openEvent}
        calledPhoneNumber={calledPhoneNumber}
        onClose={handleCloseEvent}
        onCancel={handleCloseEvent}
      />

      <AddDeferralModal
        open={openDeferral}
        onClose={() => {
          setOpenDeferral(false)
          getById()
        }}
        onCancel={() => setOpenDeferral(false)}
        workListId={contractAll?.id}
      />

      <AddLawyerEvents
        open={openLawyerEvent}
        onClose={() => setOpenLawyerEvent(false)}
        onCancel={() => setOpenLawyerEvent(false)}
      />

      <ActionModal
        open={openAssignManager}
        onCancel={handleCloseAssignManager}
        onClose={handleCloseAssignManager}
        onConfirm={handleAssignTo}
        title=" Назначить менеджеру"
        labelConfirm=" Назначить"
      >
        <Grid item xs={12}>
          <InputLabel shrink className={classes.inputLabel}>
            Менеджер
          </InputLabel>
          <AutoCompleteField
            fullWidth
            value={assignManager}
            onChange={handleChangeManager}
            options={managers}
            keyArr={'username'}
            labelKeys={['firstName', 'lastName']}
            valueKey={'username'}
            name=" assignManager"
            placeholder=" Менеджер"
          />
        </Grid>
      </ActionModal>
      <ActionModal
        open={openEmail}
        onCancel={handleCloseEmail}
        onClose={handleCloseEmail}
        onConfirm={sendEmail}
        title=" Отправить email"
        labelConfirm=" Да"
      >
        <Typography>
          Вы точно хотите отправить документ <b>Претензия и требование</b> на email?
        </Typography>
      </ActionModal>
      <ActionModal
        open={openResumptionModal}
        onCancel={() => setOpenResumptionModal(false)}
        onClose={() => setOpenResumptionModal(false)}
        onConfirm={handleUpdateLegalAssignTo}
        title=" Судебный процесc"
        labelConfirm=" Да"
      >
        <Typography>
          Вы точно хотите <b>Возобновить судебный процесc?</b>
        </Typography>
      </ActionModal>

      <BottomDialog open={openAction} onClose={() => setOpenAction(false)}>
        <Grid item className={classes.actionItems}>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant=" outlined"
              id=" call-button"
              aria-controls={openPhoneMenu ? 'call-menu' : null}
              aria-haspopup="true"
              aria-expanded={openPhoneMenu ? 'true' : null}
              onClick={openPhoneList}
            >
              <Call />
              Позвонить
            </Button>
            <Menu
              id=" call-menu"
              anchorEl={phoneAnchorEl}
              open={openPhoneMenu}
              onClose={closePhoneList}
              MenuListProps={{
                'aria-labelledby': 'call-button'
              }}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              {(eventPhoneNumbers || []).map(item => (
                <MenuItem key={item} value={item} onClick={() => handleCallPhone(item)} className={classes.phoneList}>
                  {item?.toString()?.toPhone()}
                </MenuItem>
              ))}
            </Menu>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              id=" doc-button"
              aria-controls={openDocMenu ? 'doc-menu' : null}
              aria-haspopup="true"
              aria-expanded={openDocMenu ? 'true' : null}
              variant=" outlined"
              onClick={openDocList}
            >
              <PrinterIcon />
              Печать
            </Button>
            <Menu
              id=" doc-menu"
              anchorEl={docAnchorEl}
              open={openDocMenu}
              onClose={closeDocList}
              MenuListProps={{
                'aria-labelledby': 'doc-button'
              }}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              <MenuItem
                value={'RECOGNITION_DEBT_TEMPLATE'}
                onClick={() => handleGetDoc('RECOGNITION_DEBT_TEMPLATE')}
                className={classes.docList}
              >
                Расписка о признании денежной задолженности
              </MenuItem>
              <MenuItem
                value={'COLLECTION_STATEMENT_TEMPLATE'}
                onClick={() => handleGetDoc('COLLECTION_STATEMENT_TEMPLATE')}
                className={classes.docList}
              >
                Заявление о взыскании
              </MenuItem>
              <MenuItem
                value={'ABOUT_DEBT_TEMPLATE'}
                onClick={() => handleGetDoc('ABOUT_DEBT_TEMPLATE')}
                className={classes.docList}
              >
                Справка о задолженности
              </MenuItem>
              <MenuItem
                value={'CLAIM_AND_DEMAND_TEMPLATE'}
                onClick={() => handleGetDoc('CLAIM_AND_DEMAND_TEMPLATE')}
                className={classes.docList}
              >
                Претензия и Требование
              </MenuItem>
            </Menu>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant=" outlined" onClick={() => setOpenEmail(true)}>
              <EmailIcon />
              Отправить email
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Link
              href={`https://api.whatsapp.com/send/?phone=${contractAll?.client?.mobilePhone}&text&type=phone_number&app_absent=0`}
              color=" inherit"
              underline=" none"
              target=" _blank"
              rel=" noopener noreferrer"
            >
              <Button fullWidth variant=" outlined">
                <WhatsappIcon />
                Написать на Whatsapp
              </Button>
            </Link>
          </Grid>
        </Grid>
      </BottomDialog>
    </PageContainer>
  )
}

export default ContractPage
